module.exports = __webpack_public_path__ + "static/img/btn4.4384698.png";


//////////////////
// WEBPACK FOOTER
// ./static/btn4.png
// module id = psBy
// module chunks = 1